module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.fromSpbo2) ? _c('crumbs', [_c('i', {
    staticClass: "glyphicon glyphicon-cog"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.commissionViewLan.title))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "principal-wrap"
  }, [_c('el-button-group', {
    staticClass: "role-btn-group"
  }, [_c('el-button', {
    staticClass: "role",
    class: {
      'curRole': (_vm.active == '/ib_v2')
    },
    attrs: {
      "type": "info",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.jump('/ibPrimary_v2')
      }
    }
  }, [_vm._v(_vm._s(_vm.commissionViewLan.role.ib))]), _vm._v(" "), _c('el-button', {
    staticClass: "role",
    class: {
      'curRole': (_vm.active == '/sale_v2')
    },
    attrs: {
      "type": "info",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.jump('/salePrimary_v2')
      }
    }
  }, [_vm._v(_vm._s(_vm.commissionViewLan.role.sale))])], 1), _vm._v(" "), _c('router-view', {
    attrs: {
      "status": _vm.status
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-205111da","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/CommissionSetting2/commissionView.vue
// module id = 1082
// module chunks = 1